// @flow @jsx h
import { h, Component } from 'preact'
import styles from './index.css'

type Props = {
  class: string,
  children: any
}

class FocusOnEnter extends Component<Props, {}> {
  rootEl: ?HTMLElement = null
  componentDidMount() {
    if (this.rootEl) {
      this.rootEl.focus()
    }
  }
  render() {
    return (
      <div
        // eslint-disable-next-line jsx-a11y/no-noninteractive-tabindex
        tabIndex='-1'
        ref={el => {
          this.rootEl = el
        }}
        class={this.props.class ? this.props.class : styles['focus-on-enter']}
      >
        {this.props.children}
      </div>
    )
  }
}

export { FocusOnEnter }



// WEBPACK FOOTER //
// ./src/v1/components/lib/FocusOnEnter.js